import { render, staticRenderFns } from "./stats-chart-column.vue?vue&type=template&id=09618255&"
import script from "./stats-chart-column.vue?vue&type=script&lang=js&"
export * from "./stats-chart-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports